import React, { useEffect, useState } from "react";
import { PRODUCT_VISIBILITY_OPTIONS } from "../constants/productVisibility";
import ProductCatalogColumnPicker from "./ProductCatalogColumnPicker";

export default function ProductCatalogTableControls({
  visibilityFilter,
  onVisibilityFilterChange,
  onReset,
  columns,
  visibleColumnKeys,
  onVisibleColumnKeysChange,
}) {
  const [resetConfirmation, setResetConfirmation] = useState(0);

  useEffect(() => {
    if (!resetConfirmation) return undefined;
    const timeoutId = window.setTimeout(() => setResetConfirmation(0), 1600);
    return () => window.clearTimeout(timeoutId);
  }, [resetConfirmation]);

  const reset = () => {
    onReset();
    setResetConfirmation((count) => count + 1);
  };

  return (
    <>
      <label className="flex items-center gap-2 text-sm font-medium text-zinc-700">
        Status
        <select
          aria-label="Filter by visibility"
          value={visibilityFilter}
          onChange={(event) => onVisibilityFilterChange(event.target.value)}
          className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-normal text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-200"
        >
          <option value="ALL">All statuses</option>
          {PRODUCT_VISIBILITY_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </label>
      <button
        type="button"
        onClick={reset}
        aria-live="polite"
        className={`whitespace-nowrap rounded-md border px-3 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-200 ${
          resetConfirmation
            ? "border-green-700 bg-green-50 text-green-900"
            : "border-gray-300 bg-white text-gray-800 hover:bg-gray-50 active:bg-gray-100"
        }`}
      >
        {resetConfirmation ? "Reset complete ✓" : "Reset filters & sorting"}
      </button>
      <ProductCatalogColumnPicker
        columns={columns}
        visibleColumnKeys={visibleColumnKeys}
        onChange={onVisibleColumnKeysChange}
      />
    </>
  );
}
